// Per-browser device identifier used for the trusted-device cap (max 4 devices).
// Persisted in localStorage so the same browser+profile always claims the same
// "device" slot, regardless of cookie clearing or new sessions.

const KEY = "rcsa_device_id";
const LABEL_KEY = "rcsa_device_label";

export function getOrCreateDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    // Crypto-random 16 byte id, base64url-ish. Falls back to Math.random when
    // the runtime is too old for crypto.randomUUID.
    if (window.crypto?.randomUUID) {
      id = "dev_" + window.crypto.randomUUID().replace(/-/g, "").slice(0, 24);
    } else {
      id = "dev_" + Math.random().toString(36).slice(2, 14) + Math.random().toString(36).slice(2, 14);
    }
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function getDeviceLabel() {
  // Use a cached label if the user set one in Settings; otherwise derive a
  // best-effort label from the user-agent so the device list is readable.
  const stored = localStorage.getItem(LABEL_KEY);
  if (stored) return stored;
  const ua = navigator.userAgent || "";
  let os = "Unknown OS";
  if (/Windows/i.test(ua)) os = "Windows";
  else if (/Mac OS X|Macintosh/i.test(ua)) os = "macOS";
  else if (/iPhone|iPad|iPod/i.test(ua)) os = "iOS";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/Linux/i.test(ua)) os = "Linux";
  let browser = "Browser";
  if (/Edg\//i.test(ua)) browser = "Edge";
  else if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) browser = "Chrome";
  else if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) browser = "Safari";
  else if (/Firefox\//i.test(ua)) browser = "Firefox";
  return `${browser} · ${os}`;
}

export function setDeviceLabel(label) {
  if (label && label.trim().length) localStorage.setItem(LABEL_KEY, label.trim().slice(0, 120));
}

export function devicePayload() {
  return { device_id: getOrCreateDeviceId(), device_label: getDeviceLabel() };
}
